import { configure, defineRule } from 'vee-validate';
import { localize, setLocale } from '@vee-validate/i18n';
import {
  required,
  min,
  max,
  email,
  numeric,
  integer,
  url,
  not_one_of
} from '@vee-validate/rules';
import zh_TW from '@/i18n/zh-TW/validate.json';

configure({
  generateMessage: localize({
    zh_TW
  })
});

setLocale('zh_TW');

const phone = (value) => {
  const mobileReg = /^(\+?886\\-?|0)?9\d{8}$/;

  return mobileReg.test(value);
};

defineRule('min', min);
defineRule('max', max);
defineRule('required', required);
defineRule('email', email);
defineRule('integer', integer);
defineRule('numeric', numeric);
defineRule('url', url);
defineRule('phone', phone);
defineRule('not_one_of', not_one_of);
